// react
import { useContext, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Category, Pagination } from '../../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextProject } from '../../Project.context';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// mui
import { Container, Grid, Paper, Typography } from '@mui/material';

// dialogs
import { DialogAddCategory } from '../../../../dialogs/DialogAddCategory/DialogAddCategory';

// tables
import { TableBasicCategories } from '../../../../tables/basic/TableBasicCategories/TableBasicCategories';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

export const Categories = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// params
	const paramPage = Number(searchParams.get('page') || 1);
	const paramDialog = searchParams.get('dialog');

	// state
	const [categories, setCategories] = useState<Category[]>([]);
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		perPage: 5,
	});

	// fetch categories
	const urlCategories = `${process.env.REACT_APP_API_URL}/categories?project=${project?.id}&populate=allocations.loan,allocations.conversions,allocations.utilization&page=${paramPage}&limit=${pagination.perPage}`;

	const { isLoading, refetch: refetchCategories } = useFetch({
		isEnabled: Boolean(project),
		url: urlCategories,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setCategories(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
							};
						}}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h3">{t('categories')}</Typography>
							</Grid>
							<Grid item xs={12}>
								<TableBasicCategories
									borderRadius={2}
									color="grey"
									data={categories}
									hasBorder={true}
									hasDividers={true}
									isLoading={isLoading}
									refetchCategories={refetchCategories}
									TableFooterProps={{
										numShowing: categories.length,
										pagination,
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
			<DialogAddCategory
				isOpen={paramDialog === 'addCategory'}
				onClose={() => {
					searchParams.delete('dialog');
					setSearchParams(searchParams);
				}}
				onSuccess={() => {
					refetchCategories();
					searchParams.delete('dialog');
					setSearchParams(searchParams);
				}}
			/>
		</Container>
	);
};
